import { PhoneCard } from '../models/phone_card';
import { IApiService } from '../services/api_service';

export const phoneCard = (centralApi: IApiService) => ({
  get: (id: string): Promise<PhoneCard> => {
    return centralApi.get(`/phone-card/${id}`);
  }
});
